import notificationsService from './notificationsService';

export * from './utils';
export * from './types';
export default notificationsService;



// WEBPACK FOOTER //
// ./src/services/notifications/index.ts